
class Dep {
  constructor (name) {
    this.id = new Date()
    this.subs = []
  }

  defined () {
    Dep.watch.add(this)
  }

  notify () {
    this.subs.forEach((e) => {
      if (typeof e.update === 'function') {
        try {
          e.update.apply(e)
        } catch (err) {
          console.warr(err)
        }
      }
    })
  }
}
Dep.watch = null

class Watch {
  constructor (name, fn) {
    this.name = name
    this.id = new Date()
    this.callBack = fn || function () {console.log('callback empty')}
  }

  add(dep) {
    dep.subs.push(this)
  }

  update() {
    var cb = this.callBack
    cb(this.name)
  }
}

const addHistoryMethod = (function () {
  const historyDep = new Dep()
  return function (name) {
    if (name === 'historychange') {
      return function (name, fn) {
        var event = new Watch(name, fn)
        Dep.watch = event
        historyDep.defined()
        Dep.watch = null
      }
    } else if (name === 'pushState' || name === 'replaceState') {
      var method = history[name]
      return function () {
        method.apply(history, arguments)
        historyDep.notify()
      }
    }
      
  }
}())

const init = () => {
  window.addHistoryListener = addHistoryMethod('historychange')
  history.pushState =  addHistoryMethod('pushState')
  history.replaceState =  addHistoryMethod('replaceState')
}

export default init
